import React from 'react';
import { formatDateTime } from '../utils/time';

const AuditTrailPanel = ({ auditEntries }) => {
  return (
    <div className="audit-trail">
      <header>
        <h2>Audit Log</h2>
        <p className="audit-trail__hint">Immutable records of every change for compliance review.</p>
      </header>
      <ul>
        {auditEntries.map((entry) => (
          <li key={entry._id}>
            <div className="audit-trail__header">
              <strong>{entry.action}</strong>
              <span>{formatDateTime(entry.at)}</span>
            </div>
            <div className="audit-trail__meta">
              <span>{entry.actor}</span>
              <span>
                {entry.entity} • {entry.entityId}
              </span>
            </div>
            {entry.metadata && (
              <pre className="audit-trail__metadata">{JSON.stringify(entry.metadata, null, 2)}</pre>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AuditTrailPanel;
